import Helper from '@/helper'

interface DocumentMetaProps {
  title: string
  description: string
  canonical?: string
}

/**
 * React 19 hoists these native elements into document.head and removes them
 * when the owning route unmounts, preventing stale route metadata.
 */
export function DocumentMeta({title, description, canonical}: DocumentMetaProps) {
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {canonical !== undefined && <link rel="canonical" href={canonical} />}
    </>
  )
}

export function DeploymentMeta() {
  if (!Helper.isBetaDeployment()) return null

  return <meta name="robots" content="noindex, nofollow" />
}
